<template>
  <TableComp
    v-if="dnsZones"
    :name="$t('global.dns-zones')"
    :headers="headers"
    :status="status"
    :pagination="dnsZones.pagination"
    :sort="dnsZones.sort"
    :number-of-items="dnsZones.list.length"
    empty-image="dns-zones"
    :empty-bold-message="$t('global.no-dns-zones-bold-message')"
    :empty-message="$t('global.no-dns-zones-message')"
    :empty-actions="getEmptyActions()"
    v-on:update:list="updateList"
    :header-actions="getHeaderActions()"
  >
    <template #desktop>
      <tr v-for="item in dnsZones.list" :key="item.id">
        <td>
          <div class="d-flex align-items-center">
            <router-link :to="getRouterLink(item)">{{ getDomain(item) }}</router-link>
          </div>
        </td>
        <td class="text-center">{{ getRecords(item) }}</td>
        <td class="text-center">{{ getContact(item) }}</td>
        <td class="text-end actions">
          <ThreeDotsMenu :items="getMenuItems(item)" />
        </td>
      </tr>
    </template>
    <template #mobile>
      <TableMobileRow v-for="item in dnsZones.list" :key="item.id">
        <template #header>
          <div class="d-flex align-items-center">
            <div class="flex-fill align-items-center">
              <router-link :to="getRouterLink(item)">
                {{ getDomain(item) }}
              </router-link>
            </div>
            <div class="d-flex justify-content-center">
              <ThreeDotsMenu :items="getMenuItems(item)" />
            </div>
          </div>
        </template>
        <template #content>
          <div class="row">
            <div class="col">{{ $t("global.records") }}:</div>
            <div class="col">{{ getRecords(item) }}</div>
          </div>
          <div class="row">
            <div class="col">{{ $t("global.contact") }}:</div>
            <div class="col">{{ getContact(item) }}</div>
          </div>
        </template>
      </TableMobileRow>
    </template>
  </TableComp>
</template>

<script>
import DnsZoneAdd from "@/components/smart/modals/DnsZoneAdd";
import DnsZoneDelete from "@/components/smart/modals/DnsZoneDelete";
import NavLink from "@/classes/NavLink";
import store from "@/store";
import TableComp from "@/components/display/table/TableComp";
import TableHeader from "@/classes/TableHeader";
import TableMobileRow from "@/components/display/table/TableMobileRow";
import ThreeDotsMenu from "@/components/display/ThreeDotsMenu";

export default {
  name: "DnsZonesTable",
  props: {
    dnsZones: Object,
    status: Object,
  },
  components: {
    TableComp,
    TableMobileRow,
    ThreeDotsMenu,
  },
  setup(props, { root }) {
    const headers = [
      new TableHeader(root.$t("global.domain"), undefined, "domain"),
      new TableHeader(root.$t("global.records"), "justify-content-center"),
      new TableHeader(root.$t("global.contact"), "justify-content-center"),
      new TableHeader(),
    ];

    const getContact = (item) => item?.contact;
    const getDomain = (item) => item?.domain;

    const getEmptyActions = () => [
      new NavLink(
        root.$t("global.dns-zone-add"),
        null,
        openAddForm,
        false,
        "primaryOutline",
        null,
        props.status.isLoading
      ),
    ];

    const getHeaderActions = () => [
      new NavLink(root.$t("global.dns-zone-add"), "add", openAddForm, false, null, "epsilon"),
    ];

    const getMenuItems = (item) => [
      new NavLink(root.$t("global.view"), null, getRouterLink(item), false, "default"),
      new NavLink(root.$t("global.delete"), null, openDeleteForm(item), false, "default"),
    ];

    const getRecords = (item) => item?.records;
    const getRouterLink = (item) => ({ name: "dns-zone", params: { id: item.id } });

    const openAddForm = () =>
      store.dispatch("modals/open", {
        template: DnsZoneAdd,
      });

    const openDeleteForm = (item) => () =>
      store.dispatch("modals/open", {
        template: DnsZoneDelete,
        data: { dnsZone: item },
      });

    const updateList = (event) => {
      const { pagination, sort } = event;
      store.dispatch("dnsZones/getList", {
        pageIndex: pagination?.index,
        pageSize: pagination?.size,
        sortProperty: sort?.property,
        sortDirection: sort?.direction,
      });
    };

    return {
      headers,
      updateList,
      getContact,
      getDomain,
      getEmptyActions,
      getHeaderActions,
      getMenuItems,
      getRecords,
      getRouterLink,
    };
  },
};
</script>
